export { ScreenBackground } from "./ScreenBackground"
export type { ScreenBackgroundProps } from "./ScreenBackground"
